export const AccountColumns = [
  {
    id: "actions",
    title: "Actions",
  },
  {
    id: "account_name",
    title: "Account Name",
  },
  {
    id: "account_no",
    title: "Account Number",
  },
  {
    id: "opening_balance",
    title: "Opening Balance",
  },
  {
    id: "amount",
    title: "Current Amount",
  },
  {
    id: "branch_name",
    title: "Branch Name",
  },
];
